/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos obrigatórios
 * na solicitação com base no ERP utilizado.
 *
 * Isso será substituido futuramente por uma API que irá retornar essas informações.
 *
 * por enquanto vamos criar um mock para simular essa API, mas com os valores reais.
 * No futuro, podemos substituir esse arquivo pelas requests diretamente.
 */

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  TOTVS: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SANKHYA: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SENIOR: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SENIOR_TEIXEIRA: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  USEALL: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

export default {
  getCamposObrigatorios,
};
